<template>
    <div>
        <slot
            name="default"
            v-bind="{
                click,
            }"
        />
    </div>
</template>

<script>
import XLSX from "xlsx";

export default {
    methods: {
        async click() {
            try {
                let workbook = new XLSX.utils.book_new();
                let form = XLSX.utils.json_to_sheet([
                    //
                    { ["교환권 번호"]: "0123456789" },
                    { ["교환권 번호"]: "12345678910" },
                    { ["교환권 번호"]: "23456789101" },
                ]);
                XLSX.utils.book_append_sheet(workbook, form, "대량 교환하기");
                XLSX.writeFile(workbook, "대량 교환하기 (샘플).xlsx");
            } catch (error) {
                alert(error?.message || "오류가 발생했습니다");
            }
        },
    },
};
</script>

<style></style>
